// test2602
(2602 && 0);
